module.exports = __webpack_public_path__ + "static/img/tw.870dd682.png";